import { gql } from '@apollo/client';

export const PRODUCT_VARIANT_COUNT = gql`
  query getProductVariantCount($cartId: ID!) {
    cart(id: $cartId) {
      id
      lines(first: 250) {
        edges {
          node {
            quantity
          }
        }
        productVariantCount @client
      }
    }
  }
`;

export const NAVIGATION = gql`
  query getNavigation {
    navigationV1 {
      id
      sections {
        id
        name
        text
        url
        hideOnMobile
        sections {
          id
          name
          text
          url
          sections {
            id
            name
            text
            hideOnDesktop
            links {
              id
              text
              url
              hideOnDesktop
              withArrow
              __typename
            }
            __typename
          }
          __typename
        }
        links {
          ... on Level3Section {
            id
            name
            text
            hideOnDesktop
            links {
              id
              text
              url
              color
              withArrow
              hideOnDesktop
              __typename
            }
            __typename
          }
        }
        menuTileGroup {
          type
          tiles {
            id
            text
            url
            image {
              file {
                url
                details {
                  image {
                    height
                    width
                  }
                }
              }
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
